module.exports = __webpack_public_path__ + "img/lev-circle.06ad156f.svg";